import { menuToggle } from "./components/menu";
import { summaryToggle } from "./components/summary";


window.addEventListener("DOMContentLoaded", () => {
  menuToggle();
  summaryToggle();
});
